import { State } from "pages/Rules/Form/context/types";
import { Rule } from "pages/Rules/common/types";

import { getContentToSave } from "pages/Rules/Form/context/ruleSelectors";
import { getCloudStorage } from "pages/Rules/Form/context/ruleSelectors";

export default function canLinkToFolder(state: State): boolean {
  const { rule } = state;

  return (
    isEmailFlow(rule) &&
    isExpectedAction(rule) &&
    saveAttachments(rule) &&
    hasLinkSecurity(rule)
  );
}

function isEmailFlow(rule: Rule) {
  return rule.targetType === "EMAIL_FLOW";
}

function isExpectedAction(rule: Rule) {
  if (rule.actionType === "REPLACE_ATTACHMENTS") return true;
  if (rule.actionType === "PROTECT_EMAILS") return true;
  return false;
}

function saveAttachments(rule: Rule) {
  const contentToSave = getContentToSave(rule);
  return contentToSave.content.some(content => content.type === "ATTACHMENTS");
}

function hasLinkSecurity(rule: Rule): boolean {
  const storage = getCloudStorage(rule);
  return Boolean(storage.linkSecurity);
}
